/* Formulaire COD Timberline — 0 dépendance, ~6 Ko.
   Ce que fait ce fichier, dans l'ordre :
     1. suit la sélection des options et recalcule le prix depuis Shopify ;
     2. récupère les marqueurs publicitaires (UTM, gclid, fbclid, _fbp, _fbc) ;
     3. envoie la commande au serveur ;
     4. redirige vers /pages/thankyou en emportant la valeur réelle.
   Le point 4 est celui qui compte : c'est lui qui permettra à Google Ads
   d'enregistrer autre chose que 0,00 MAD. */
(function () {
  'use strict';

  /* Cinq fiches portent la section deux fois : la balise <script> est donc
     chargée deux fois, et sans cette garde le fichier s'exécutait deux fois,
     posait deux écouteurs sur le même formulaire et envoyait deux commandes.
     Constaté le 17/09 sur #10000 et #10001, même client, même seconde. */
  if (window.__codFormMaison) return;
  window.__codFormMaison = true;

  /* Le prix s'écrit d'un seul tenant : 1299 Dhs. Pas de virgule des milliers —
     elle se lit comme une décimale au premier coup d'œil, et sur un chiffre de
     quarante pixels c'est le premier coup d'œil qui décide. */
  function argent(centimes) {
    var n = centimes / 100;
    var entier = Math.round(n * 100) % 100 === 0;
    return (entier ? String(Math.round(n)) : n.toFixed(2)) + ' Dhs';
  }

  /* La regle du serveur, mot pour mot : on retire ce qui n'est pas un chiffre,
     on enleve l'indicatif et les zeros de tete, et il doit rester neuf chiffres
     commencant par 5, 6, 7 ou 8. Le serveur refuserait de toute facon — mais il
     refuse apres le clic, quand le client croit avoir commande. Ici il le sait
     pendant qu'il tape, et il corrige. */
  function telephoneMarocain(brut) {
    var c = String(brut || '').replace(/\D/g, '');
    if (c.indexOf('00212') === 0) c = c.slice(5);
    else if (c.indexOf('212') === 0) c = c.slice(3);
    c = c.replace(/^0+/, '');
    return /^[5-8]\d{8}$/.test(c) ? '+212' + c : null;
  }

  var MSG_TEL = 'رقم غير صحيح · 10 أرقام تبدأ بـ 06 أو 07';

  function cookie(nom) {
    var m = document.cookie.match('(^|;)\\s*' + nom + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  /* Les paramètres de campagne survivent à la navigation interne : on les
     range en session dès la première page vue. Releasit ne les captait
     qu'une fois sur deux — d'où les commandes sans UTM. */
  /* Le cookie que gtag depose au premier clic publicitaire. Il vaut
     « GCL.<horodatage>.<gclid> » : le gclid est le TROISIEME segment, pas la
     valeur entiere. Il vit quatre-vingt-dix jours, la ou sessionStorage meurt
     a la fermeture de l'onglet. */
  function gclidDuCookie() {
    var brut = cookie('_gcl_aw');
    if (!brut) return '';
    var bouts = decodeURIComponent(brut).split('.');
    return bouts.length >= 3 ? bouts[2] : '';
  }

  function marqueurs() {
    var url = new URLSearchParams(location.search);
    /* gbraid et wbraid remplacent gclid quand le clic vient d'un iPhone au
       suivi restreint. Sans eux, une part du trafic Apple — et ce compte est
       entierement mobile — arrive sans aucune trace. */
    var cles = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content',
                'utm_term', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid'];
    var out = {};
    cles.forEach(function (c) {
      var v = url.get(c);
      if (v) { try { sessionStorage.setItem('cod_' + c, v); } catch (e) {} }
      try { v = v || sessionStorage.getItem('cod_' + c); } catch (e) {}
      if (v) out[c] = v;
    });

    /* Le cas qu'on perdait : le client clique sur l'annonce, ferme, revient
       plus tard en direct, et commande. L'URL n'a plus rien, la session non
       plus — le cookie, lui, se souvient. On note d'ou vient le gclid retenu
       pour pouvoir mesurer ce que ce repli rattrape. */
    if (out.gclid) {
      out.gclid_source = 'url';
    } else {
      var c = gclidDuCookie();
      if (c) { out.gclid = c; out.gclid_source = 'cookie'; }
    }

    out.fbp = cookie('_fbp');
    out.fbc = cookie('_fbc');
    out.url_source = location.href;
    return out;
  }

  /* Une barre qui flotte au-dessus de la page. Halo rend aussi la colonne du
     produit « sticky » : la confondre avec une barre d'achat faisait rater le
     vrai bloc. Seul « fixed » désigne une barre. */
  function flottant(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      var pos = getComputedStyle(n).position;
      if (pos === 'fixed') return true;
    }
    return false;
  }

  /* Le vrai bloc d'achat de cette fiche. Le signe qui ne trompe pas : son champ
     caché « id » porte une variante de CE produit — les cartes de produits liés
     portent celles d'un autre. Reste la barre d'achat collante, qui porte la même
     variante : on lui préfère le bloc ancré dans la page, et on ne se rabat sur
     elle que s'il n'y en a pas d'autre. */
  function blocAchatDuTheme(ids) {
    var formes = document.querySelectorAll('form[action*="/cart/add"]');
    var exclus = '[class*="quick"],[class*="modal"],[class*="drawer"],[class*="popup"]';
    var candidats = [];
    for (var i = 0; i < formes.length; i++) {
      var f = formes[i];
      if (f.closest && f.closest(exclus)) continue;
      var champ = f.querySelector('[name="id"]');
      if (!champ || ids.indexOf(String(champ.value)) === -1) continue;
      var bouton = f.querySelector('[name="add"]');
      if (!bouton || bouton.offsetParent === null) continue;
      candidats.push(f);
    }
    for (var j = 0; j < candidats.length; j++) {
      if (!flottant(candidats[j])) return candidats[j];
    }
    return candidats[0] || null;
  }

  function demarrer(racine) {
    var form = racine.querySelector('.cod__form');
    if (!form) return;

    var balise = racine.querySelector('[data-variantes]');
    var variantes = [];
    try { variantes = JSON.parse(balise.textContent) || []; } catch (e) {}

    var elPrix = racine.querySelector('[data-prix]');
    var elCompare = racine.querySelector('[data-compare]');
    var elTotal = racine.querySelector('[data-total]');
    var elEco = racine.querySelector('[data-eco]');
    var elMsg = racine.querySelector('[data-message]');
    /* L'écran de l'offre n'existe que si la collection du produit en désigne
       une. Absent, le formulaire garde exactement le chemin d'avant : envoi
       direct, commande créée, page de remerciement.

       Les trois adresses sont la même à un mot près : le réglage de section
       n'en porte qu'une, et on ne va pas en demander trois à Younes pour un
       serveur qu'on écrit nous-mêmes. */
    var ecranOffre = racine.querySelector('[data-offre]');
    var urlAttente = racine.dataset.endpoint.replace(/\/cod\/commande$/, '/cod/attente');
    var urlDecision = racine.dataset.endpoint.replace(/\/cod\/commande$/, '/cod/decision');
    /* Les frais viennent de la collection, posés en centimes par le thème.
       L'encadré qui les affiche est entièrement rendu en Liquid : ils ne
       changent ni avec la couleur ni avec la quantité, il n'y a rien à
       recalculer ici. Le Worker, lui, relit la valeur chez Shopify avant de
       créer la commande — changer ce nombre dans la console ne change rien à
       ce qui sera facturé. */
    var frais = parseInt(racine.dataset.frais, 10) || 0;
    var bouton = form.querySelector('.cod__envoyer');
    var champQte = form.querySelector('[name="quantite"]');
    var ouverture = Date.now();
    var choix = {};
    var courante = variantes.filter(function (v) { return v.available; })[0]
                 || variantes[0];

    if (courante && courante.options) {
      courante.options.forEach(function (val, i) { choix[i + 1] = val; });
    }

    function trouver() {
      var positions = Object.keys(choix);
      return variantes.filter(function (v) {
        return positions.every(function (p) {
          return v.options[p - 1] === choix[p];
        });
      })[0];
    }

    /* Le thème porte ses propres pastilles de couleur, au-dessus de la galerie :
       ce sont elles qui commandent la photo, le libellé « Color : … » et le prix
       du haut. Le formulaire porte les siennes, en bas. Deux sélecteurs pour une
       seule couleur : le client cochait « Rouge » en bas et voyait toujours le
       marron en haut. On les marie dans les deux sens — cliquer l'étiquette d'une
       radio du thème laisse le thème faire tout le reste lui-même. */
    var radiosTheme = [];
    var horsFiche = '[class*="quick"],[class*="modal"],[class*="drawer"],[class*="popup"]';
    document.querySelectorAll('.product-form__swatch input[type="radio"], variant-radios input[type="radio"]')
      .forEach(function (r) {
        if (r.closest(horsFiche)) return;
        if (!r.closest('[data-option-index]')) return;
        if (radiosTheme.indexOf(r) === -1) radiosTheme.push(r);
      });
    /* Les pastilles agrandies servaient encore l'image de 40 pixels que Halo
       demande à Shopify : à 64 pixels elle devient floue. Shopify redimensionne
       à la volée, il suffit de le lui demander. */
    document.querySelectorAll('.product-form__swatch .pattern').forEach(function (p) {
      var fond = p.style.backgroundImage;
      if (fond && fond.indexOf('_40x') > -1) {
        p.style.backgroundImage = fond.replace('_40x', '_240x');
      }
    });

    var enMiroir = false;

    function positionDe(radio) {
      var champ = radio.closest('[data-option-index]');
      return String(parseInt(champ.dataset.optionIndex, 10) + 1);
    }

    /* Le formulaire vient de changer : on coche la même chose en haut. */
    function pousserVersLeTheme() {
      radiosTheme.forEach(function (r) {
        if (r.checked || choix[positionDe(r)] !== r.value) return;
        var etiquette = r.id ? document.querySelector('label[for="' + r.id + '"]') : null;
        enMiroir = true;
        (etiquette || r).click();
        enMiroir = false;
      });
    }

    /* Le haut vient de changer : on rapatrie la sélection dans le formulaire. */
    function lireLeTheme() {
      var bouge = false;
      radiosTheme.forEach(function (r) {
        if (!r.checked) return;
        var pos = positionDe(r);
        if (choix[pos] === r.value) return;
        choix[pos] = r.value;
        bouge = true;
      });
      return bouge;
    }

    function peindreLesPuces() {
      Object.keys(choix).forEach(function (pos) {
        racine.querySelectorAll('.cod__puce[data-position="' + pos + '"]').forEach(function (x) {
          x.classList.toggle('est-actif', x.dataset.valeur === choix[pos]);
        });
      });
    }

    radiosTheme.forEach(function (r) {
      r.addEventListener('change', function () {
        if (enMiroir) return;
        if (!lireLeTheme()) return;
        peindreLesPuces();
        rafraichir();
      });
    });

    /* Au chargement, c'est le thème qui a raison : il a déjà affiché une photo et
       un libellé. Le formulaire s'aligne sur lui, jamais l'inverse. */
    if (radiosTheme.length && lireLeTheme()) peindreLesPuces();

    /* Sans pastilles de thème, personne ne prévient la galerie : on clique
       nous-mêmes la vignette qui porte le média de la variante choisie. */
    var dernierMedia = null;
    function suivreLaGalerie() {
      if (pilote || !courante) return;
      if (radiosTheme.length) { pousserVersLeTheme(); return; }
      var media = courante.featured_media && courante.featured_media.id;
      if (!media || media === dernierMedia) return;
      dernierMedia = media;
      var cibles = document.querySelectorAll('[data-media-id="' + media + '"]');
      var vignette = null;
      for (var i = 0; i < cibles.length; i++) {
        if (cibles[i].closest && cibles[i].closest('.productView-nav')) { vignette = cibles[i]; break; }
      }
      var cible = vignette || cibles[0];
      if (cible) cible.click();
    }

    function rafraichir() {
      if (!pilote) {
        var v = trouver();
        if (v) courante = v;
      }
      if (!courante) return;
      var qte = Math.max(1, parseInt(champQte.value, 10) || 1);
      /* Le grand chiffre reste le prix du produit, quantité comprise : c'est
         lui qui doit se comparer au prix barré et au badge de remise. Les
         frais de livraison ont leur encadré juste en dessous — ils s'ajoutent
         une seule fois par commande, pas par article. Le total encaissé, lui,
         part dans la commande Shopify, donc dans STK, et s'affiche sur la page
         de remerciement. */
      var articles = courante.price * qte;
      elPrix.textContent = argent(articles);
      var remise = (courante.compare_at_price || 0) - courante.price;
      if (elCompare) {
        elCompare.textContent = argent(courante.compare_at_price * qte);
        elCompare.hidden = remise <= 0;
      }
      if (elEco) {
        elEco.hidden = remise <= 0;
        if (remise > 0) {
          elEco.textContent = '−' + Math.round(remise * 100 / courante.compare_at_price) + ' %';
        }
      }
      /* Le montant reste en haut, en gros et en or. Le bouton ne porte plus
         que l'action : deux prix sur le même écran, c'est un de trop. */
      if (elTotal) elTotal.textContent = argent(articles + frais);
      /* Le prix barré suit l'article, jamais la livraison : sinon la remise
         affichée ne correspondrait plus à rien. */
      bouton.disabled = !courante.available;
      if (!courante.available) {
        elMsg.textContent = 'Ce choix est épuisé. Sélectionnez une autre option.';
        elMsg.className = 'cod__message est-alerte';
      } else if (elMsg.className.indexOf('est-alerte') > -1) {
        elMsg.textContent = ''; elMsg.className = 'cod__message';
      }
      suivreLaGalerie();
    }

    /* Deux sélecteurs de taille et deux boutons de commande sur la même
       fiche, c'est une hésitation offerte au client. Quand le thème affiche
       déjà ses options et son prix, on efface les nôtres, on masque son bouton
       d'achat, et on lit la variante qu'il a choisie. Un seul chemin. */
    var idsProduit = variantes.map(function (v) { return String(v.id); });
    var formeTheme = blocAchatDuTheme(idsProduit);
    var champVariante = formeTheme && formeTheme.querySelector('[name="id"]');
    var pilote = false;

    if (champVariante) {
      pilote = true;
      var opts = racine.querySelector('.cod__options');
      if (opts) opts.hidden = true;
      var blocPrix = racine.querySelector('.cod__prix');
      if (blocPrix) blocPrix.hidden = true;

      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        var champ = f.querySelector('[name="id"]');
        if (!champ || idsProduit.indexOf(String(champ.value)) === -1) return;
        f.querySelectorAll('[name="add"], .shopify-payment-button')
          .forEach(function (el) { el.style.display = 'none'; });
      });

      formeTheme.parentNode.insertBefore(racine, formeTheme.nextSibling);

      /* Le thème réécrit ce champ caché à chaque changement d'option, sans
         événement fiable selon les versions : une vérification légère suit
         donc la valeur elle-même. */
      setInterval(function () {
        var id = String(champVariante.value || '');
        if (!id || (courante && String(courante.id) === id)) return;
        var trouvee = variantes.filter(function (x) { return String(x.id) === id; })[0];
        if (trouvee) { courante = trouvee; rafraichir(); }
      }, 400);

    } else {
      /* Plusieurs modèles de fiche n'ont aucun bloc d'achat : ces produits ne se
         commandaient que par Releasit, et depuis son retrait ils ne se commandent
         plus du tout. Le formulaire prend sa place, au bas de la colonne du
         produit, et garde ses propres options : le thème n'expose ici aucun champ
         de variante à lire. */
      /* Attention à l'endroit. `appendChild` posait le formulaire tout en bas de
         la colonne, après la description et ses accordéons : pour changer de
         couleur le client devait remonter chercher les petites pastilles du
         thème, ou descendre très loin. On le glisse juste sous les options,
         là où le regard s'arrête déjà, et la description suit. */
      var ancre = document.querySelector('.productView-variants')
               || document.querySelector('.productView-price')
               || document.querySelector('h1.productView-title');
      if (ancre && ancre.parentElement) {
        ancre.parentElement.insertBefore(racine, ancre.nextSibling);
      } else {
        var titre = document.querySelector('h1.productView-title') || document.querySelector('h1');
        if (titre && titre.parentElement) titre.parentElement.appendChild(racine);
      }
    }

    /* Les promesses du thème — livraison gratuite, ajustement garanti, dix
       mille clients — rassurent mieux après le formulaire qu'avant : on les
       lit quand on hésite à appuyer, pas quand on découvre la fiche. */
    var promesses = document.querySelector('.productView-icon-with-text');
    if (promesses && racine.parentNode && !promesses.contains(racine)) {
      racine.parentNode.insertBefore(promesses, racine.nextSibling);
    }

    /* La barre orange du bas. Elle déménage dans <body> : restée dans la colonne
       du produit, elle hériterait d'un parent « transform » ou « overflow » et
       cesserait d'être fixe. Elle ne paraît que lorsque le bouton de commande a
       quitté l'écran — tant qu'il est visible, deux boutons identiques se
       feraient concurrence. */
    var barre = racine.querySelector('.cod__barre');
    if (barre) {
      document.body.appendChild(barre);
      barre.querySelector('.cod__barre-bouton').addEventListener('click', function () {
        bouton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var vide = form.querySelector('input[required]:placeholder-shown');
        if (vide) vide.focus({ preventScroll: true });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          barre.hidden = entrees[0].isIntersecting;
        }).observe(bouton);
      } else {
        barre.hidden = false;
      }
    }

    /* On ne corrige pas au troisieme chiffre : tant que le numero est trop court
       pour etre juge, on se tait. Des qu'il a la longueur d'un vrai numero, ou
       que le client quitte le champ, on tranche. */
    var champTel = form.querySelector('[name="telephone"]');
    var errTel = form.querySelector('[data-err="telephone"]');

    function verifierTelephone(pendantLaSaisie) {
      var chiffres = champTel.value.replace(/\D/g, '');
      var bon = !!telephoneMarocain(champTel.value);
      var taire = pendantLaSaisie && !bon && chiffres.length < 9;
      errTel.textContent = (bon || taire) ? '' : MSG_TEL;
      /* Pas de classe : la bordure se dit ici, le fichier CSS n'a pas besoin
         de connaitre cet etat. */
      champTel.style.borderColor = (bon || taire) ? '' : '#ff6b6b';
      return bon;
    }

    champTel.addEventListener('input', function () { verifierTelephone(true); });
    champTel.addEventListener('blur', function () {
      if (champTel.value) verifierTelephone(false);
    });

    racine.querySelectorAll('.cod__puce').forEach(function (b) {
      b.addEventListener('click', function () {
        var pos = b.dataset.position;
        choix[pos] = b.dataset.valeur;
        racine.querySelectorAll('.cod__puce[data-position="' + pos + '"]')
              .forEach(function (x) { x.classList.remove('est-actif'); });
        b.classList.add('est-actif');
        rafraichir();
      });
    });

    racine.querySelectorAll('.cod__stepper button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(champQte.value, 10) || 1) + parseInt(b.dataset.pas, 10);
        champQte.value = Math.max(1, Math.min(10, n));
        rafraichir();
      });
    });
    champQte.addEventListener('input', rafraichir);

    function erreur(texte) {
      elMsg.textContent = texte;
      elMsg.className = 'cod__message est-erreur';
      bouton.disabled = false;
      bouton.classList.remove('est-occupe');
    }

    /* ── Les quatre repères du parcours ──────────────────────────────────
     *
     *  Sur trente jours, 66 912 visites et 861 commandes : on savait que
     *  98,7 % repartaient, jamais d'où. Le formulaire est à nous, donc il
     *  peut le dire lui-même. Quatre repères suffisent à transformer un taux
     *  en diagnostic :
     *
     *      cod_vu      le formulaire est arrivé sous les yeux du client
     *      cod_debut   il a touché le premier champ
     *      cod_envoi   il a validé
     *      cod_offre   il a répondu à l'offre
     *
     *  Entre deux repères, ce qui manque est ce qu'on perd. `cod_erreur` dit
     *  en plus quel champ a bloqué — c'est le téléphone qu'on soupçonne.
     *
     *  Ça passe par le gtag déjà chargé par la boutique (G-1M5HTGN6CH est
     *  configuré sur la fiche produit, vérifié le 28/09) : pas de script en
     *  plus, pas de serveur en plus, et les repères se recoupent tout seuls
     *  avec la source de trafic que GA4 connaît déjà.
     *
     *  Rien de tout cela ne doit pouvoir empêcher une commande : tout est
     *  enveloppé, et un bloqueur de pub ne fait que rendre la mesure muette.
     */
    function pister(nom, extra) {
      try {
        if (typeof window.gtag !== 'function') return;
        var p = { produit: racine.dataset.produit || '', variante: (courante && courante.id) || '' };
        for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) p[k] = extra[k]; }
        window.gtag('event', nom, p);
      } catch (e) {}
    }

    /* Vu, une seule fois : le formulaire entre dans l'écran. C'est le premier
       chiffre qui manquait — combien descendent seulement jusque-là. */
    if ('IntersectionObserver' in window) {
      var oeil = new IntersectionObserver(function (entrees) {
        if (!entrees[0].isIntersecting) return;
        oeil.disconnect();
        pister('cod_vu', {});
      }, { threshold: 0.25 });
      oeil.observe(form);
    }

    /* Commencé, une seule fois : le premier champ touché. Entre « vu » et
       « commencé » se cache tout ce que la page n'a pas réussi à dire. */
    var demarre = false;
    form.addEventListener('focusin', function (ev) {
      if (demarre || !ev.target.matches('input')) return;
      demarre = true;
      pister('cod_debut', { secondes: Math.round((Date.now() - ouverture) / 1000) });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      form.querySelectorAll('.cod__err').forEach(function (e) { e.textContent = ''; });
      elMsg.textContent = ''; elMsg.className = 'cod__message';

      /* Un numero faux, c'est une commande qui arrive chez Stockout et que
         personne ne peut appeler : elle finit en « Faux numero ». Autant le dire
         maintenant, tant que le client est devant son ecran. */
      if (!verifierTelephone(false)) {
        champTel.focus({ preventScroll: true });
        champTel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        pister('cod_erreur', { champ: 'telephone' });
        return erreur(MSG_TEL);
      }
      /* Le navigateur a déjà refusé les champs vides avant d'arriver ici ;
         ce qui passe le téléphone part vraiment. */
      pister('cod_envoi', { secondes: Math.round((Date.now() - ouverture) / 1000) });

      var donnees = Object.assign({
        nom: form.nom.value,
        telephone: form.telephone.value,
        ville: form.ville.value,
        adresse: form.adresse ? form.adresse.value : '',
        voiture: form.voiture ? form.voiture.value : '',
        quantite: parseInt(champQte.value, 10) || 1,
        variante: String(courante && courante.id || ''),
        societe: form.societe.value,
        duree_secondes: (Date.now() - ouverture) / 1000
      }, marqueurs());

      bouton.disabled = true;
      bouton.classList.add('est-occupe');

      /* Le filet de sécurité. Si le serveur ne répond pas — panne, coupure
         réseau, n'importe quoi — on ne perd pas la vente : on reconstruit un
         panier Shopify avec ce que le client vient de saisir et on le laisse
         finir sur le checkout de Shopify, qui ne dépend de personne d'autre.
         Vérifié le 17/09 : /cart/<variante>:<qté> renvoie bien un 302 vers
         /checkouts/cn/… */
      function basculerVersShopify() {
        var nomComplet = (donnees.nom || '').trim().split(/\s+/);
        var c = {
          'checkout[shipping_address][first_name]': nomComplet[0] || '',
          'checkout[shipping_address][last_name]': nomComplet.slice(1).join(' '),
          'checkout[shipping_address][address1]': donnees.adresse || '',
          'checkout[shipping_address][city]': donnees.ville || '',
          'checkout[shipping_address][country]': 'Morocco',
          'checkout[shipping_address][phone]': donnees.telephone || ''
        };
        /* Les mêmes clés d'attributs que la commande normale : quel que soit le
           chemin emprunté, l'équipe retrouve la même fiche. */
        c['attributes[Nom - الإسم]'] = donnees.nom || '';
        c['attributes[Téléphone - الهاتف]'] = donnees.telephone || '';
        c['attributes[Ville - المدينة]'] = donnees.ville || '';
        c['attributes[Adresse ]'] = donnees.adresse || '';
        if (donnees.voiture) c['attributes[modèle de voiture]'] = donnees.voiture;
        if (donnees.utm_campaign) c['attributes[UTM campaign]'] = donnees.utm_campaign;
        /* Ce chemin ne passe pas par le Worker : sans ces lignes, une commande
           de secours arrive sans aucune attribution. Les attributs du panier
           sont le seul endroit ou les marqueurs peuvent la suivre. */
        if (donnees.gclid) c['attributes[gclid]'] = donnees.gclid;
        if (donnees.gbraid) c['attributes[gbraid]'] = donnees.gbraid;
        if (donnees.wbraid) c['attributes[wbraid]'] = donnees.wbraid;
        if (donnees.ttclid) c['attributes[ttclid]'] = donnees.ttclid;
        if (donnees.utm_source) c['attributes[UTM source]'] = donnees.utm_source;

        var qs = Object.keys(c).filter(function (k) { return c[k]; })
          .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(c[k]); })
          .join('&');
        window.location.href = '/cart/' + donnees.variante + ':' + donnees.quantite + '?' + qs;
      }

      /* Huit secondes suffisaient depuis un bureau en fibre. Sur une 4G faible,
         entre la poignée de main TLS et les quatre appels que le serveur
         enchaîne — chercher le client, lire la variante, créer la commande,
         prévenir Meta — la coupure tombait avant la réponse, et le client
         atterrissait sur le checkout Shopify. Vide, de surcroît : le nouveau
         checkout ignore les paramètres checkout[shipping_address]. Quinze
         secondes, et un second essai avant de renoncer : une coupure de réseau
         dure rarement deux fois de suite, et le serveur répond en trois. */
      function envoyer(url, corps, essai) {
        var minuteur = new AbortController();
        var expire = setTimeout(function () { minuteur.abort(); }, 15000);
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(corps),
          signal: minuteur.signal
        }).then(function (r) {
          clearTimeout(expire);
          return r.json().then(function (j) { return { code: r.status, corps: j }; });
        }).catch(function (e) {
          clearTimeout(expire);
          /* Le second essai ne risque pas de doubler la commande : le serveur
             refuse deux commandes du même numéro à dix minutes d'intervalle,
             et une réponse à l'offre déjà traitée ne crée rien. */
          if (essai < 2) return envoyer(url, corps, essai + 1);
          throw e;
        });
      }

      function allerMerci(corps) {
        /* Le ttclid repart dans l'URL : le pixel TikTok chargé sur la page de
           remerciement le lit tout seul et rattache l'achat au clic. Sans lui,
           PlaceAnOrder part sans identifiant et TikTok ne l'attribue à rien. */
        var tt = marqueurs().ttclid;
        window.location.href = racine.dataset.merci
          + '?commande=' + encodeURIComponent(corps.commande || '')
          + '&valeur=' + encodeURIComponent(corps.valeur || 0)
          + '&devise=' + encodeURIComponent(corps.devise || 'MAD')
          + (tt ? '&ttclid=' + encodeURIComponent(tt) : '');
      }

      /* L'écran de l'offre. La saisie est déjà chez le Worker — il ne reste
         qu'un jeton et un oui/non à lui dire. Si cet appel-ci échoue, on ne
         rebascule surtout pas sur le checkout : la commande arriverait en
         double. Le balayage du serveur la créera dans la minute. */
      function montrerOffre(jeton) {
        ecranOffre.hidden = false;
        document.body.style.overflow = 'hidden';
        ecranOffre.scrollIntoView({ block: 'start' });

        var reste = parseInt(ecranOffre.dataset.secondes, 10) || 90;
        var total = reste;
        var elCompte = ecranOffre.querySelector('[data-offre-compte]');
        var elBarre = ecranOffre.querySelector('.cod-offre__barre span');
        var repondu = false;
        var tic;

        function repondre(oui, cause) {
          if (repondu) return;
          repondu = true;
          clearInterval(tic);
          /* « expire » se distingue de « non » : l'un a refusé, l'autre n'a
             rien vu. Les deux finissent sans l'offre, ils ne se corrigent pas
             de la même façon. */
          pister('cod_offre', {
            reponse: oui ? 'oui' : (cause || 'non'),
            secondes: total - reste,
          });
          ecranOffre.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          if (elCompte) elCompte.textContent = '…';
          envoyer(urlDecision, { jeton: jeton, offre: oui }, 1)
            .then(function (r) { allerMerci((r && r.corps) || {}); })
            .catch(function () { allerMerci({}); });
        }

        pister('cod_offre_vue', {});

        ecranOffre.querySelector('[data-offre-oui]')
          .addEventListener('click', function () { repondre(true); });
        ecranOffre.querySelector('[data-offre-non]')
          .addEventListener('click', function () { repondre(false); });

        function battre() {
          if (elBarre) elBarre.style.width = Math.max(0, 100 * reste / total) + '%';
          if (elCompte) {
            var m = Math.floor(reste / 60), s = reste % 60;
            elCompte.textContent = m + ':' + (s < 10 ? '0' : '') + s;
          }
        }
        battre();
        tic = setInterval(function () {
          reste -= 1;
          battre();
          if (reste <= 0) repondre(false, 'expire');
        }, 1000);
      }

      envoyer(ecranOffre ? urlAttente : racine.dataset.endpoint, donnees, 1).then(function (res) {
        if (res.code === 422 && res.corps.details) {
          Object.keys(res.corps.details).forEach(function (champ) {
            var e = form.querySelector('[data-err="' + champ + '"]');
            if (e) e.textContent = res.corps.details[champ];
          });
          return erreur('Vérifiez les champs en rouge.');
        }
        /* 429 = trop vite ou trop de commandes : c'est un refus volontaire, on
           l'affiche. Tout autre échec est une panne : on bascule. */
        if (res.code === 429) return erreur(res.corps.erreur);
        if (!res.corps.ok) return basculerVersShopify();

        /* Le serveur a pris la saisie en dépôt : on montre l'offre, et c'est
           la réponse du client qui déclenchera la commande. */
        if (res.corps.jeton) return montrerOffre(res.corps.jeton);

        /* La valeur part dans l'URL. Le pixel « Google Ads Purchase » du thème
           teste littéralement url.indexOf("/pages/thankyou") : tant que la
           redirection garde ce chemin, la conversion Google continue. */
        allerMerci(res.corps);
      }).catch(function () {
        basculerVersShopify();
      });
    });

    rafraichir();
  }

  /* Cinq fiches portent la section deux fois : une posée dans leur modèle du
     temps des essais, une venue de theme.liquid. Deux formulaires, deux boutons
     d'achat, et un client qui hésite. On n'en garde qu'un.

     On gardait le premier venu, en le croyant identique à l'autre. Il ne l'est
     pas : celui des modèles a gardé ses réglages d'essai — « Nom complet —
     الإسم الكامل », « Confirmer la commande » — et comme il est écrit plus haut
     dans la page, c'est lui qui survivait. Cinq fiches montraient donc un
     formulaire différent des vingt-trois autres.

     Celui de theme.liquid porte toujours le même identifiant, puisqu'il n'est
     posé qu'une fois, à la racine : `cod-cod-form-maison`. C'est lui qu'on
     garde — il est le seul dont les réglages valent pour toute la boutique. */
  var blocs = document.querySelectorAll('.cod');
  var garde = null;
  for (var i = 0; i < blocs.length; i++) {
    if (blocs[i].id === 'cod-cod-form-maison') { garde = blocs[i]; break; }
  }
  if (!garde) garde = blocs[0];
  for (var j = 0; j < blocs.length; j++) {
    if (blocs[j] !== garde && blocs[j].parentNode) {
      blocs[j].parentNode.removeChild(blocs[j]);
    }
  }
  if (garde) demarrer(garde);
})();
